/* global axios */
import ApiClient from './ApiClient';

class ConversationReportsAPI extends ApiClient {
  constructor() {
    super('conversation_reports', { accountScoped: true });
  }

  get({ page, since, until: untilTs, assigneeId } = {}) {
    return axios.get(this.url, {
      params: { page, since, until: untilTs, assignee_id: assigneeId },
    });
  }

  download({ since, until: untilTs, assigneeId } = {}) {
    return axios.get(`${this.url}/download`, {
      params: { since, until: untilTs, assignee_id: assigneeId },
      responseType: 'blob',
    });
  }
}

export default new ConversationReportsAPI();
